/**
 * Scene 7 video param object
 * @param {string} urlElem - Library video element
 * @return {videoObj} - Retrun video param obj
 */
function videoParamObj(urlElem) {
    var videoUrl = urlElem.data('videourl');
    var paramValues = videoUrl.substr(videoUrl.indexOf('?'), videoUrl.length - 1).replace('?', '');
    var keyArray = paramValues.split('&');
    var videoObj = {};
    keyArray.forEach(function (item) {
        var valueSplit = item.split('=');
        var paramKey = valueSplit[0];
        var paramValue = valueSplit[1];
        videoObj[paramKey] = paramValue;
    });
    return videoObj;
}
export default {
    init: function ($container = $('.product-video')) {
        var vidUrl = $('.scene7libUrl').val();
        var url = new URL(vidUrl);
        var scriptExists = $(`script[src="${vidUrl}"]`).length;
        var script;
        if (!scriptExists) {
            script = document.createElement('script');
            script.src = url.href;
            script.type = 'text/javascript';
            document.head.appendChild(script);
        }

        const initialVideoPlayer = () =>
            $container.each(function () {
                var containerId = $(this).find('.vidContainer').attr('id');
                var videoObj = videoParamObj($(this));
                /* eslint-disable */
                var videoViewer = new s7viewers.VideoViewer({
                    "containerId": containerId,
                    "params": {
                        "asset": videoObj.asset,
                        "serverurl": videoObj.serverUrl,
                        "videoserverurl": videoObj.videoserverurl
                    }
                });
                videoViewer.init();
            });

        if (scriptExists) {
            // without setTimeout the video is not display event script already exists.
            setTimeout(() => {
                initialVideoPlayer();
            }, 200);
        } else {
            script.addEventListener('load', () => {
                initialVideoPlayer();
            })
        }
    }
};
